import { ReactComponent as ChevronDown } from "assets/images/iconsV2/chevron-down.svg";
import Input from "components/v2/Input/Input";
import Dropdown, { DropdownOption } from "components/v2/Dropdown/Dropdown";
import "./InputDropdownGroup.scss";
import InputDropdown from "../InputDropdown/InputDropdown";

interface InputDropdownGroupProps {
  /** Label for the entire group */
  label?: string;
  /** Array of input field names for react-hook-form integration */
  names: string[];
  /** Name for the dropdown field for react-hook-form integration */
  dropdownName?: string;
  /** Array of options for the dropdown */
  options: DropdownOption[];
  /** Placeholder texts for each input field */
  inputPlaceholders?: string[];
  /** Placeholder for the dropdown */
  dropdownPlaceholder?: string;
  /** Callback when dropdown value changes */
  onDropdownSelect?: (value: any) => void;
  /** If true, marks the group as required */
  required?: boolean;
  /** Width of the entire group container */
  width?: string | number;
  /** Custom class name */
  className?: string;
  /** If true, uses InputDropdown component instead of Dropdown */
  useInputDropdown?: boolean;
  /** Max width for the InputDropdown component */
  inputDropdownMaxWidth?: string | number;
  /** If true, aligns the dropdown menu to the right */
  alignRight?: boolean;
}

export default function InputDropdownGroup({
  label,
  names,
  dropdownName,
  options,
  inputPlaceholders = [],
  dropdownPlaceholder = "Select",
  onDropdownSelect,
  required = false,
  width = "100%",
  className = "",
  useInputDropdown,
  inputDropdownMaxWidth,
  alignRight,
}: InputDropdownGroupProps) {
  return (
    <div className={`input-dropdown-group ${className}`} style={{ width }}>
      {label && <label className={`input-dropdown-group__label ${required ? "required" : ""}`}>{label}</label>}
      <div className="input-dropdown-group__container">
        {names.map((name, index) => (
          <div key={name} className="input-dropdown-group__input">
            <Input name={name} placeholder={inputPlaceholders[index] || ""} required={required} />
          </div>
        ))}
        {useInputDropdown ? (
          <div className="input-dropdown-group__input-dropdown" style={{ maxWidth: inputDropdownMaxWidth ?? "84px" }}>
            <InputDropdown
              iconRight={<ChevronDown />}
              options={options}
              name={dropdownName}
              onSelect={onDropdownSelect}
              placeholder={dropdownPlaceholder}
              alignRight={alignRight}
            />
          </div>
        ) : (
          <div className="input-dropdown-group__dropdown">
            <Dropdown
              name={dropdownName}
              options={options}
              placeholder={dropdownPlaceholder}
              onSelect={onDropdownSelect}
              required={required}
              alignRight={alignRight}
            />
          </div>
        )}
      </div>
    </div>
  );
}

InputDropdownGroup.defaultProps = {
  label: undefined,
  dropdownName: undefined,
  inputPlaceholders: [],
  dropdownPlaceholder: "Select",
  required: false,
  width: "100%",
  onDropdownSelect: undefined,
  className: "",
  useInputDropdown: false,
  inputDropdownMaxWidth: undefined,
  alignRight: false,
};
